import { render, staticRenderFns } from "./CatFilter.vue?vue&type=template&id=6938d0bf&"
import script from "./CatFilter.vue?vue&type=script&lang=js&"
export * from "./CatFilter.vue?vue&type=script&lang=js&"
import style0 from "./CatFilter.vue?vue&type=style&index=0&id=6938d0bf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TopFilter: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/TopFilter.vue').default})
